export default {
    book: '{product} buchen',
    age_limit: 'Mindestalter {age} Jahre',
    upgrade_product: 'Produkt aktualisieren',
    choose_product: '{product} wählen',
    days: '{count} Tag | {count} Tage',
    login_register: 'Login/Registrieren',
    keyless_benefits: {
        label: 'Straight to car {0}',
        highlight: 'rental service™',
        list: {
            cant_lose_the_key: 'Vollversicherung',
            zero_excess: 'kein Überschuss',
            phone_as_a_key: 'Smartphone als Schlüssel',
            straight_to_car: 'Keine Wartezeit',
            no_queues: 'Kein Warten',
            online_id_check: 'Online Identitätsnachweis',
            self_checkout: 'Selbst-Check-out',
        },
    },
}



// WEBPACK FOOTER //
// ./node_modules/greenmotion-shared/lang/de/quotes/vehicle_card.js